<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-form ref="eventForm">
        <v-layout justify-center class="pa-3" column>
          <v-flex xs12>
            <v-text-field label="事件名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="事件描述" prepend-icon="$vuetify.icons.comment"
                        rows="1" auto-grow v-model="form.description" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
            </v-textarea>
          </v-flex>
          <v-layout>
            <v-flex xs6>
              <v-flex xs12>
                <v-text-field label="回调地址" prepend-icon="$vuetify.icons.code" v-model="form.addressURL" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="业务系统名称" prepend-icon="$vuetify.icons.title" v-model="form.institutionId" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <l-autocomplete
              :disabled="disabledFlag"
              label="关联消息模板"
              :get-data="findTemplate"
              item-text="name"
              prepend-icon="$vuetify.icons.code"
              v-model="form.templateList"
              chips
              multiple
            ></l-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout justify-center v-if="form.templateList.length!==0">
          <v-subheader class="pa-3">关联模板属性配置</v-subheader>
        </v-layout>
        <v-layout v-if="form.templateList.length!==0" column class="pa-3" >
          <v-layout v-for="(c,i) in form.templateConfigList" :key="i" justify-center class="mb-2">
            <v-flex xs8>
              <v-card class="pa-3">
                <v-flex xs12>
                  <v-text-field label="模板名称" v-model="c.name" readonly prepend-icon="$vuetify.icons.title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group mandatory row v-model="c.isUseable" label="是否可用" prepend-icon="$vuetify.icons.lock" :disabled="disabledFlag" :rules="[$rules.requiredS()]">
                    <v-radio :value="0" label="不可用"></v-radio>
                    <v-radio :value="1" label="可用"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-layout>
                  <v-flex xs6>
                    <l-select-datetime label="模板使用开始时间" v-model="c.startDatetime" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></l-select-datetime>
                  </v-flex>
                  <v-flex xs6>
                    <l-select-datetime label="模板使用截止时间" v-model="c.endDatetime" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></l-select-datetime>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
      <v-card-actions>
        <v-layout justify-center v-if="!disabledFlag">
          <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="submit">提交</v-btn>
        </v-layout>
        <v-layout v-else justify-center>
          <v-btn class="primary" @click="disabledFlag=!disabledFlag">修改</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'eventDetail',
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      disabledFlag: true,
      form: {
        name: '',
        addressURL: '',
        description: '',
        institutionId: '',
        templateList: [],
        templateConfigList: []
      },
      initFinished: false,
    }
  },
  created () {
    console.log(this.formData)
    this.init()
  },
  methods: {
    init () {
      this.form.name = this.formData.name
      this.form.description = this.formData.description
      this.form.institutionId = this.formData.institutionId
      this.form.addressURL = this.formData.addressURL
      for (let i = 0; i < this.formData.eventTmplts.length; i++) {
        this.form.templateList.push(this.formData.eventTmplts[i].msgTmplt)
      }
    },
    async findTemplate (searchValue) {
      try {
        let url = '/messageApi/admin/getMsgTmplt'
        let {items, amount} = await this.$store.dispatch('message/getList', {pagination: {pages: 1, rowsPerPage: 10}, search: {key: 'name', value: searchValue}, url: url})
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async submit () {
      if (this.$refs.eventForm.validate()) {
        let tmpltList = []
        let isUseableList = []
        let useTimeList = []
        for (let i = 0; i < this.form.templateList.length; i++) {
          tmpltList.push(this.form.templateList[i].id)
        }
        for (let i = 0; i < this.form.templateConfigList.length; i++) {
          isUseableList.push(this.form.templateConfigList[i].isUseable)
          useTimeList.push({
            'startTime': this.$L.time.toTimeStamp(this.form.templateConfigList[i].startDatetime),
            'endTime': this.$L.time.toTimeStamp(this.form.templateConfigList[i].endDatetime),
          })
        }
        let params = {
          'msgEvent': {
            'id': this.formData.id,
            'name': this.form.name,
            'description': this.form.description,
            'institutionId': this.form.institutionId,
            'addressURL': this.form.addressURL
          },
          'tmpltList': tmpltList,
          'isUseableList': isUseableList,
          'useTimeList': useTimeList,
        }
        // console.log(params)
        let url = '/messageApi/admin/addMsgEvent'
        this.loading = true
        try {
          let res = await this.$store.dispatch('message/addActions', {params: params, url: url})
          if (res.data.code + '' === '200') {
            this.$L.alert('success', {message: '添加成功'})
            this.disabledFlag = true
            this.$store.commit('message/setEventRefresh', true)
          }
          else {
            this.$L.alert('error', {message: '添加失败，原因:' + res.data.msg})
          }
        }
        catch (e) {
          console.log(e)
        }
        finally {
          this.loading = false
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    }
  },
  watch: {
    'form.templateList': {
      handler (val) {
        console.log(this.form.templateList)
        console.log(this.formData.eventTmplts)
        for (let i = 0; i < this.form.templateList.length; i++) {
          for (let j = 0; j < this.formData.eventTmplts.length; j++) {
            if (this.form.templateList[i].name === this.formData.eventTmplts[j].msgTmplt.name) {
              let tmp = this.formData.eventTmplts[j]
              this.form.templateConfigList.push({
                name: tmp.msgTmplt.name,
                isUseable: tmp.isUsable,
                startDatetime: this.$L.time.stringify(tmp.startTime),
                endDatetime: this.$L.time.stringify(tmp.endTime)
              })
              this.formData.eventTmplts.splice(j, 1)
              console.log(this.form.templateConfigList)
              return
            }
          }
        }
        let newList = []
        let flag = false
        for (let i = 0; i < this.form.templateList.length; i++) {
          flag = false
          for (let j = 0; j < this.form.templateConfigList.length; j++) {
            if (this.form.templateList[i].name === this.form.templateConfigList[j].name) {
              newList.push(this.form.templateConfigList[j])
              flag = true
              break
            }
          }
          if (!flag) {
            newList.push({
              name: this.form.templateList[i].name,
              isUseable: 1,
              startDatetime: '',
              endDatetime: ''
            })
          }
        }
        this.form.templateConfigList = newList
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
